import apiClient from '../clienteFebosAPI';

const RESOURCE = '/v2/documents';

export const ioCreateCustomDocument = (payload) => {
  const { documentId, ...query } = payload.query || {};
  const params = apiClient.queryParams(query);
  return apiClient
    .post(`${RESOURCE}/${payload.type}?${params}`,
      payload.formData, { operacionId: 'io.customDocuments.create' });
};

export const ioGetCustomDocument = (type, id, options) => {
  const params = apiClient.queryParams(options);
  return apiClient
    .get(`${RESOURCE}/${type}/${id}?${params}`, { operacionId: 'io.customDocuments.get' });
};

export const ioPatchCustomDocument = (type, id, body) => apiClient
  .patch(`${RESOURCE}/${type}/${id}`, body, { operacionId: 'io.customDocuments.patch' });

export const ioDiscardCustomDocument = (type, id) => apiClient
  .delete(`${RESOURCE}/${type}/${id}`, { operacionId: 'io.customDocuments.delete' });

export const getDocumentDetail = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient
    .get(`${RESOURCE}/${payload.codeType}/${payload.id}?${params}`,
      { operacionId: 'get.document.detail' });
};

export const ioGetMaterialDetail = (type, payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient
    .get(`${RESOURCE}/${type}?${params}`, { operacionId: 'io.materials.get' });
};

export const ioGetMaterialRequestDetail = (type, id, payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient
    .get(`${RESOURCE}/${type}/${id}?${params}`, { operacionId: 'io.materials.get' });
};

export const ioCreateMaterial = (type, payload) => apiClient
  .post(`${RESOURCE}/${type}`,
    payload, { operacionId: 'io.materials.create' });

export const ioCreateMaterialRequest = (type, payload, parameters) => {
  const params = apiClient.queryParams(parameters);
  return apiClient
    .post(`${RESOURCE}/${type}?${params}`,
      payload, { operacionId: 'io.materials.create' });
};

export const ioSetMaterial = (type, id, payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient
    .put(`${RESOURCE}/${type}/${id}?${params}`,
      payload, { operacionId: 'io.materials.set' });
};

export const ioCreateCatalog = (type, payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient
    .post(`${RESOURCE}/${type}?${params}`,
      payload, { operacionId: 'io.catalogs.create' });
};

export const ioSetCatalog = (type, id, payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient
    .put(`${RESOURCE}/${type}/${id}?${params}`,
      payload, { operacionId: 'io.catalogs.set' });
};

export const ioGetDocuments = (type, payload = {}) => {
  const params = apiClient.queryParams(payload);
  return apiClient
    .get(`${RESOURCE}/${type}?${params}`, { operacionId: 'io.documents.get' });
};

export const ioListCustomDocuments = (type, payload = {}) => {
  const params = apiClient.queryParams(payload);
  const query = params ? `?${params}` : '';
  return apiClient
    .get(`${RESOURCE}/${type}${query}`, { operacionId: 'io.documents.listar' });
};
